import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const FormStepRoot = superstyled({
  name: 'FormStep',
  slot: 'Root',
  tag: Box,
  styles: () => ({
    '& fieldset': {
      border: 'none',
      margin: 0,
      padding: 0,
      minWidth: 0,

      '&:disabled': {
        opacity: 0.6
      }
    },

    '& legend.sr-only': {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0
    }
  })
});

export const StepTitle = superstyled({
  name: 'FormStep',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.fontSize.lg
  })
});

export const StepDescription = superstyled({
  name: 'FormStep',
  slot: 'Description',
  tag: Text,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
    fontSize: theme.typography.fontSize.sm
  })
});

export const FieldsContainer = superstyled({
  name: 'FormStep',
  slot: 'FieldsContainer',
  tag: Box,
  propsNeeded: ['columns', 'gap'],
  styles: ({ theme, columns = 1, gap = 'md' }) => {
    const gapMap = {
      sm: theme.spacing(2),
      md: theme.spacing(3),
      lg: theme.spacing(4)
    };

    return {
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: gapMap[gap],
      marginBottom: theme.spacing(4),

      // Responsive behavior
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: columns > 2 ? 'repeat(2, 1fr)' : `repeat(${columns}, 1fr)`
      },

      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr'
      }
    };
  }
});

export const FieldError = superstyled({
  name: 'FormStep',
  slot: 'FieldError',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.error.main,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.error.light,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.error.main}`
  })
});

export const ActionsContainer = superstyled({
  name: 'FormStep',
  slot: 'ActionsContainer',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(4),
    // paddingTop: theme.spacing(3),
    borderTop: `1px solid ${theme.palette.border.light}`
  })
});

export const AutoContinueAnnouncement = superstyled({
  name: 'FormStep',
  slot: 'AutoContinueAnnouncement',
  tag: Text,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2)
  })
});
